import { render } from "./main-header.vue?vue&type=template&id=bf35c2d6&lang=html"
import script from "./main-header.vue?vue&type=script&lang=js"
export * from "./main-header.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\unistroy\\market\\market-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__